import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import classnames from 'classnames';
const icons = {
  back: '<i class="fas fa-chevron-left"></i>',
  add: '<i class="fas fa-plus"></i>',
  edit: '<i class="fas fa-edit"></i>'
}

const Header = ({ header, user }) => (
  <header className={classnames({ 'navbar': true, 'has-shadow': true, 'is-sticky': (header.title !== null) })}>
    <div className="left">
    {
      header.left && (!header.left.admin || header.left.admin === user.admin) ?
        <Link to={header.left.url}
          className={classnames({ 'button': true, 'is-white': !header.left.isButton })}
          dangerouslySetInnerHTML={{__html: 
            icons[header.left.text]? icons[header.left.text] : header.left.text
          }} 
        />
      :
        <div className="navbar-burger burger is-hidden-tablet">
          <span></span>
          <span></span>
          <span></span>
        </div>
    }
    </div>
    <div className="title">{header.title}</div>
    <div className="right">
    {
      header.right && (!header.right.admin || header.right.admin === user.admin)?
        <Link to={header.right.url}
          className={classnames({ 'button': true, 'is-pulled-right': true, 'is-white': !header.right.isButton })}
          dangerouslySetInnerHTML={{__html: 
            icons[header.right.text]? icons[header.right.text] : header.right.text
          }}
        />
      :
        ""
    }
    </div>
  </header>
)
export default connect(
  state => ({ 
    user: state.user,
    header: state.header
  }),
)(Header)


// WEBPACK FOOTER //
// ./src/components/Header.js